import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/services/auth/auth.service';
import { LoaderService } from '@app/interceptors/loaderInterceptor/loader.service';

/**
 * @description defines selector and templateUrl for component
 * @class AuthCallbackComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})

/**
 * @description
 * @export
 * @class AuthCallbackComponent
 * @implements {OnInit}
 */
export class AuthCallbackComponent implements OnInit {

  /**
   * @description Creates an instance of AuthCallbackComponent.
   * @param {AuthService} authService
   */
  constructor(public readonly authService: AuthService, 
    public loaderService: LoaderService) { }

  /**
   * @description calls on ngOnInit
   * @memberof AuthCallbackComponent
   */
  ngOnInit() {
    this.authService.completeAuthentication()
  }
}
